﻿export function initMobileNavigation() {
    const mobileSelect = document.getElementById('mobile-resource-selection');
    const mobileSelectButton = document.querySelector('.resource-hub-header__mobile-select-cta');
    const host = window.location.origin;
    mobileSelectButton.addEventListener('click', function(event){
        event.preventDefault();
        const selectedValue = mobileSelect.value;
        if(selectedValue === "Select Option"){
            return;
        }
        else if(selectedValue === "All"){
            window.location.href = `${host}/resources`;
        }
        else if(selectedValue === "Blog"){
            window.location.href = `${host}/blogs`;
        }
        else if(selectedValue === "Guides"){
            window.location.href = `${host}/guides`;
        }
        else if(selectedValue === "Research"){
            window.location.href = `${host}/research`;
        }
        else if(selectedValue === "Research"){
            window.location.href = `${host}/research`;
        }
        else if(selectedValue === "Client Stories"){
            window.location.href = `${host}/client-story`;
        }
        else if(selectedValue === "Podcasts"){
            window.location.href = `${host}/podcasts`;
        }
        else if(selectedValue === "Webinars"){
            window.location.href = `${host}/webinars`;
        }
        else if(selectedValue === "Events"){
            window.location.href = `${host}/events`;
        }
        else if(selectedValue === "Workshops"){
            window.location.href = `${host}/workshops`;
        }
    })
}